<template>
  <FlexCol class="w-full min-h-screen max-w-full text-slate-800">
    <!-- Linha -->
    <Flex class="grow h-full w-full max-w-full min-h-0">
      <!-- Coluna A (esquerda) -->
      <TheSideMenu ref="leftEl" v-model="lateralMenu" v-if="user" />

      <!-- Coluna B (direita) bg-[#F1F5F9] -->
      <FlexCol class="w-full max-w-full overflow-auto min-h-0" :style="rightHeightStyle">
        <Flex justify-end items-center class="h-14 border-b border-slate-200 bg-white px-4 shadow-sm" v-if="user">
          <UserHeadBar />
        </Flex>

        <div class="grow w-full min-h-0 bg-gray-100/50" :class="[{ 'p-5': user }]">
          <router-view />
        </div>
      </FlexCol>
    </Flex>
    <Flex justify-end items-center class="px-5 bg-slate-200/80 border-t border-gray-200 h-8 shrink-0" v-if="user">
      <nav class="text-slate-800 text-right text-sm">Portal de Comissões © Softwaresul 2020 - 2026</nav>
    </Flex>
  </FlexCol>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'

const store = useStore()
const lateralMenu = ref(true)
const user = computed(() => store.state.user)

const leftEl = ref(null)
const rightHeight = ref(null)

let ro = null
let observedEl = null
let rafId = null

const getLeftDomEl = () => {
  const v = leftEl.value
  return v?.$el ?? v ?? null
}

const measureLeftHeight = () => {
  const el = getLeftDomEl()
  if (!el) return null
  // mais robusto que offsetHeight
  return Math.round(el.getBoundingClientRect().height)
}

const syncHeight = () => {
  const h = measureLeftHeight()
  if (h == null) return
  rightHeight.value = h
}

const attachObserver = () => {
  const el = getLeftDomEl()
  if (!el) return

  // reanexa se o nó mudou
  if (observedEl !== el) {
    if (ro) ro.disconnect()

    ro = new ResizeObserver(() => {
      if (rafId) cancelAnimationFrame(rafId)
      rafId = requestAnimationFrame(syncHeight)
    })

    ro.observe(el)
    observedEl = el
  }

  syncHeight()
}

// Ajuda quando a altura muda por animação/transição ou por mudanças internas não captadas
const burstSync = () => {
  syncHeight()
  setTimeout(syncHeight, 0)
  setTimeout(syncHeight, 50)
  setTimeout(syncHeight, 150)
  setTimeout(syncHeight, 300)
}

const rightHeightStyle = computed(() => {
  if (!user.value || rightHeight.value == null) return {}
  return { height: `${rightHeight.value}px` }
})

let onWinResize = null

onMounted(() => {
  onWinResize = () => burstSync()
  window.addEventListener('resize', onWinResize)
})

onBeforeUnmount(() => {
  if (onWinResize) window.removeEventListener('resize', onWinResize)
  if (ro) ro.disconnect()
  if (rafId) cancelAnimationFrame(rafId)
  ro = null
  observedEl = null
  rafId = null
})

// Reanexa e re-mede quando:
// - menu aparece/desaparece (user)
// - abre/fecha coisas do menu (lateralMenu)
// - ref troca (HMR / re-render)
watch(
  [user, lateralMenu, leftEl],
  async () => {
    await nextTick()
    attachObserver()
    burstSync()
  },
  { immediate: true },
)
</script>
